import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from '../utils/constants';
import Modal from "react-modal";
import moment from 'moment';
import StepHeader from '../screens/registration/stepHeader'
import { compileString } from 'sass';

Modal.setAppElement("#root");


// {head,subHeader}
const Header = () => {
  const navigate = useNavigate();

  const history = useNavigate();
  const marqueeRef = useRef(null);
  const [isLoading, setLoader] = useState(false);


  const loadScripts = () => {
    // This array contains all the files/CDNs 
    // const dynamicScripts = [
    //   'js/jquery.sticky.js',
    //   'js/metisMenu.min.js',
    //   'js/metisMenu-active.js',
    //   'js/main.js',
    //   'js/azia.js'
    // ];

    // for (let i = 0; i < dynamicScripts.length; i++) {
    //   const node = document.createElement('script');
    //   node.src = dynamicScripts[i];
    //   node.type = 'text/javascript';
    //   node.async = false;
    //   document.getElementsByTagName('head')[0].appendChild(node);
    // }
  }

  useEffect(() => {
    loadScripts();

  }, []);


  const openPdf = () => {
    var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
    window.open(URL, null);
  }

  // Exhibition From Date
  const dateString = sessionStorage.getItem('exhibitionDateFrom');
  const isFromDateValid = moment(dateString, "DD/MM/YYYY", true).isValid()
  const dateStringMoment = isFromDateValid ? moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString).format('DD MMMM YYYY')
  const dateObject = new Date(dateStringMoment);
  const fromDay = dateObject.getDate();
  const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
  const fromYear = dateObject.getFullYear();
  const fromDate = `${fromDay} ${fromMonth} ${fromYear}`;

  // Exhibition to Date
  const dateString1 = sessionStorage.getItem('exhibitionDateTo');
  const isToDateValid = moment(dateString1, "DD/MM/YYYY", true).isValid()
  const dateString1Moment = isToDateValid ? moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString1).format('DD MMMM YYYY')
  const dateObject1 = new Date(dateString1Moment);
  const toDay = dateObject1.getDate();
  const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
  const toYear = dateObject1.getFullYear();
  const toDate = `${toDay} ${toMonth} ${toYear}`;

  // Exhibition Logo File Path
  const logoPath = sessionStorage.getItem('sessionLogoPath')
  const ExhibitionEmail = JSON.parse(sessionStorage.getItem('sessionExhibitionEmail'))
  const ExhibitionMobileNo = JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo'))

  // Exhibition Address
  const address = sessionStorage.getItem('exhibitionAddress')
  // console.log(dateString, dateStringMoment, dateObject)

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const onLogoutClick = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";


  return (
    <>
      {isLoading ? (
        <Loader></Loader>
      ) : (
        null
      )}

      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu}
        ></div>
      )}


      <div
        className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
          }`}
      >
        <div className="mobile-menu-header exhibitor-menu-header">
          <button
            onClick={closeMobileMenu}
            className="exhibitor-menu-close-btn text-white"
          >
            ×
          </button>
          <div className="user-info exhibitor-user-info">
            <h4 className="text-uppercase fw-semibold text-white fw-bold">
              {sessionStorage.getItem("sessionExhibitionName")}
            </h4>
          </div>
        </div>
        <div className="mobile-menu-content exhibitor-menu-content">
          <div className="menu-section exhibitor-details-section">
            <h6 className="exhibitor-section-title">Exhibition Details</h6>
            <p className="exhibitor-detail-text mb-2">
              {sessionStorage.getItem("exhibitionDateFrom")} -{" "}
              {sessionStorage.getItem("exhibitionDateTo")} <br />
              {address}
            </p>
          </div>
          <div className="menu-section exhibitor-details-section">
            <h6 className="exhibitor-section-title">For Assistance</h6>
            <p className="exhibitor-detail-text mb-2">
              {ExhibitionMobileNo} <br />
              {ExhibitionEmail} <br />
            </p>
          </div>

          <div className="menu-section exhibitor-links-section">
            <h6 className="exhibitor-section-title gap-1">Quick Links</h6>
            <a
              href={corporateLink}
              target="_blank"
              rel="noopener noreferrer"
              className="exhibitor-menu-link mb-2 mobi"
              onClick={closeMobileMenu}
            >
              For new corporate site please <span className="text-primary ms-1"> Click here</span>
            </a>

          </div>
        </div>
      </div>

      {/* app-Header */}
      <div className="app-header header sticky app-heder-with-logo">
        <div className="container-fluid main-container">
          <div className="d-flex">
            <a className="logo-horizontal " href="index.html">
              <img
                src={logoPath} className="header-brand-img desktop-logo" alt="logo" />
            </a>
            <div class="side-header">
              {/* <a class="header-brand1" >
                                     <img src={logoPath} class="header-brand-img header-brand-img-1 light-logo1" alt="top-left logo" />
                                 </a> */}
              <div class="side-header">
                <a class="header-brand1" >
                  <img src={logoPath} class="header-brand-img header-brand-img-1 light-logo1 m-0" alt="top-left logo" />
                </a>
              </div>

              {/* <p className=" header-assistance text-white">
                                     For Assistance
                                     <br>
                                     </br>
                                     {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                         {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                     </>
                                     )) : null}
                                     <br>
                                     </br>
                                     {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                         <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                     )) : null}
                                 </p> */}


              {/* <div class="right-logo">
                <p className='right-logo-text' style={{ top: '20px' }}>Owned and Organised by</p>
                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
              </div> */}

            </div>
            <p style={{ color: 'white' }}className=" header-logo-name" >{fromDate} - {toDate} <br></br>
              {address}
            </p>
            <p style={{ color: 'white' }} className=" header-assistance">
              For Assistance
              <br>
              </br>
              {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
              </>
              )) : null}
              <br>
                {/* ` ${(data)}`(i != ExhibitionMobileNo.length - 1 ? ',' : null) */}
              </br>
              {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                <a style={{ color: 'white' }} href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
              )) : null}
            </p>


            <div class="right-logo">
              <p className='right-logo-text' style={{ top: '20px', color: 'white' }}>Owned and Organised by</p>
              <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
            </div>

          </div>
          <div className="marquee-text">
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="5"
              ref={marqueeRef}
              onMouseOver={() => marqueeRef.current?.stop()}
              onMouseOut={() => marqueeRef.current?.start()}
            >
              <b>Disclaimer and Ownership:</b> {disclaimer}
            </marquee>
          </div>
        </div>

        <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none">
          <button
            onClick={toggleMobileMenu}
            className="exhibitor-menu-toggle-btn"
          >
            <span className="exhibitor-menu-toggle-bar"></span>
            <span className="exhibitor-menu-toggle-bar"></span>
            <span className="exhibitor-menu-toggle-bar"></span>
          </button>
        </div>
      </div>
      {/* /app-Header */}
    </>
  );
}
export default Header;

